import { makeStyles } from '@vakantiesnl/components/src/styles/themes/themewrapper';

export const useStyles = makeStyles()((theme) => ({
	controlsPane: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	filterCount: {
		color: theme.primary.color.default,
	},
}));
